/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, {
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import Shimmer from 'react-shimmer-effect';

import { saveCalendarExercise } from '../../ducks/calendarActions';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const RestTimeInput = styled('input')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border: none;
  border-radius: 5px;
  min-height: 34px;
  max-height: 34px;
`;

const alreadySavedGlobal = new Set();

const PreSaveRestTimeTable = ({
  contentIndex,
  content,
  date,
  dayNumber,
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;

  const dispatch = useDispatch();

  const handleAutoSave = (contentIndexParam) => {
    const submissionObject = {
      date: moment(effectiveDate).format('YYYY-MM-DD'),
      type: 'rest',
      restTime: 60,
    };
    if (content.description) {
      submissionObject.description = content.description;
    }
    if (content.groupingLetter) {
      submissionObject.groupingLetter = content.groupingLetter;
    }
    const formattedDate = moment(effectiveDate).format('YYYY-MM-DD');
    dispatch(saveCalendarExercise(
      currentUser,
      contentIndexParam,
      submissionObject,
      formattedDate,
      () => {},
      {},
      content.assignedId,
    ));
  };

  /** the CellMeasurer wrapped around each row in the virtualized list
   * can cause remounting of the item a few times as it measures
   * the "just in time" height, this can cause multiple firings of this
   * handleAutoSave funtion (which is a problem because it will create 3 of the same items in the data base).
   * To get around that we save the item by id
   * in the global set that will persist renders and if we have alreay saved
   * the item them we will not fire that function again.
   */
  useEffect(() => {
    if (!alreadySavedGlobal.has(content.assignedId)) {
      alreadySavedGlobal.add(content.assignedId);
      handleAutoSave(contentIndex);
    }
  }, []);

  return (
    <Container>
      <Shimmer><RestTimeInput /></Shimmer>
    </Container>
  );
};

PreSaveRestTimeTable.propTypes = {
  contentIndex: PropTypes.number.isRequired,
  content: PropTypes.instanceOf(Object).isRequired,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
};

PreSaveRestTimeTable.defaultProps = {
  date: null,
  dayNumber: null,
};

export default PreSaveRestTimeTable;
